

































































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
@Component({})
export default class extends Vue {
    private created(): void {}
    private mounted(): void {}
}
